<template>
  <div>
    <div v-cloak
         @drop.prevent="onChange"
         @dragover.prevent>
      <v-file-input
          :value="file"
          v-bind="localProps"
          :loading="loading"
          :error="!!errorMessage.length"
          :error-messages="errorMessage"
          @click:clear="deleteFile"
          @change="onChange"
          :hint="getHint"
      >
      </v-file-input>
    </div>
  </div>
</template>

<script>

const multipartFileAxiosConfig = {
  headers: {
    'Content-Type': 'multipart/form-data'
  },
}

export default {
  name: "TcnFileInput",
  components: {},
  props: {
    value: {default: ''},
    options: {type: Object, required: true},
    schema: {type: Object, required: true},
    fullSchema: {type: Object, required: true},
    fullKey: {type: String, required: true},
    label: {type: String, default: ''},
    htmlDescription: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    rules: {type: Array, required: true},
    on: {type: Object, required: true},
  },
  data() {
    return {
      file: null,
      resultFile: null,
      dragging: false,
      alertContent: [],
      loading: false,
      url: "",
      errorMessage: ""
    }
  },
  computed: {
    getHint() {
      return `Dozwolone rozszerzenia: ${this.contentMediaType}. Maksymalny rozmiar pliku: ${this.fileSizeLimitInMB} MB.`
    },

    uploadParam() {
      return this.schema['uploadParam'] || "file"
    },

    localProps() {
      const defaultProps = {
        multiple: false,
        "persistent-placeholder": true,
        "prepend-icon": "",
        placeholder: "Wskaż lub upuść plik",
        "prepend-inner-icon": "mdi-file",
      }
      const global = this.options['fieldProps']
      const textField = this.options['textFieldProps'] !== undefined && this.options['textFieldProps'] !== null ? this.options['textFieldProps'] : {}
      const forThis = this.schema['x-props'] !== undefined && this.schema['x-props'] !== null ? this.schema['x-props'] : {}
      let result = {...defaultProps, global}
      result = {...result, ...textField}
      result = {...result, ...forThis}
      return result
    },

    showAlert() {
      return this.alertContent.length > 0
    },

    contentMediaType() {
      return this.schema['contentMediaType'] || "*/*"
    },

    fileSizeLimitInMB() {
      return this.schema['fileSizeLimitInMB'] || 5
    },

  },
  watch: {},
  methods: {
    onChange(e) {

      this.file = e?.dataTransfer?.files[0] || e
      if (this.file !== null && this.isValid(this.file)) {
        this.upload(this.file)
      }
    },

    async upload() {
      this.loading = true
      const formData = new FormData()
      formData.append(this.uploadParam, this.file)

      await this.options.httpLib.post(`${this.url}`, formData, multipartFileAxiosConfig)
          .then((response) => {
            let data = response.data
            let obj = {}
            obj.id = data.id
            this.resultFile = obj // add to result
            this.file.id = obj.id
            this.loading = false
          })
          .catch((error) => {
            console.log(error)
            this.loading = false
            this.errorMessage = this.$t('uploadError', {name: this.file.name})
          })
    },

    deleteFile() {
      if (this.file.id !== undefined) {
        this.options.httpLib.delete(`${this.url}/${this.file.id}`)
            .then((response) => {
              let status = response.status
              if (status === 204) {
                this.file = null
                this.errorMessage = ""
              }
              this.clearAlert()
            })
            .catch((error) => {
              console.error(error)
            })
      } else {
        this.file = null
        this.errorMessage = ""
      }

    },

    isValid(file) {
      if (this.contentMediaType !== "*/*" && !file.type.match(this.contentMediaType)) {
        this.errorMessage = this.$t('contentTypeMessage', {name: file.name})
        return false
      } else if (!((file.size / (1024 * 1024)).toFixed(2) <= this.fileSizeLimitInMB.toFixed(2))) {
        this.errorMessage = this.$t('sizeFileLimit', {name: file.name, size: this.fileSizeLimitInMB})
        return false
      } else {
        return true
      }
    },


  },
  mounted() {
    this.url = this.schema['fileUrl']

  }
}
</script>
<i18n lang="i18n">
{
  "pl": {
    "uploadText": "Dodaj lub upuść pliki aby wgrać",
    "deleteAllFilesLabel": "Usuń wszystkie pliki",
    "errorOccurred": "Wystąpił błąd",
    "limitMessage": "Plik o nazwie {name} nie został dodany - Przekroczono limit załączników (max. {limit} załączników.)",
    "contentTypeMessage": "Plik o nazwie {name} nie został dodany - Niezgodny typ pliku.",
    "sizeFileLimit": "Plik o nazwie {name} nie może być wgrany, przekroczono dozwolony rozmiar pliku: {size} MB.",
    "uploadError": "Nie udało się wgrać pliku o nazwie {name}."
  },
  "en": {
    "uploadText": "Drop file or click to upload",
    "deleteAllFilesLabel": "Delete all files",
    "errorOccurred": "Error occurred",
    "limitMessage": "File named {name} was not added - Attachment limit exceeded (max {limit} attachments).",
    "contentTypeMessage": "File named {name} was not added - Incompatible file type.",
    "sizeFileLimit": "File named {name} cannot be uploaded, the allowed file size has been exceeded: {size} MB.",
    "uploadError": "File named {name} cannot be uploaded"
  }
}
</i18n>
<style scoped lang="css">

</style>
